export default __webpack_public_path__ + "static/media/jklogo.2e7f9ca9.png";